//Replicate for stage and prod
export const environment = {
  production: false,
  environment: 'stage',
  title: 'Sierra Order',
  name: 'sierra-order',
  featureFlags: {
    receipts: true,
  },
  proxyUrls: {
    assetApi: 'https://asset.api.stage.sierra-erp.com',
    itemApi: 'https://item.api.stage.sierra-erp.com',
    userMasterApi: 'https://user.api.stage.sierra-erp.com',
    inventoryApi: 'https://inventory.api.stage.sierra-erp.com',
    orderApi: 'https://order.api.stage.sierra-erp.com',
    financeApi: 'https://finance.api.stage.sierra-erp.com',
    reportApi: 'https://reportgenerator.dev.sierra-erp.com',
  },
};
